// O hub de distribuicao so tem o que escolher quando a conta tem as politicas
// de capacidade (assignment_v2 + advanced_assignment). Sem elas (25 de 25
// contas em staging), o hub mostrava um card so e forcava um clique a mais:
// nesse caso ele leva direto para a lista de politicas, e a lista deixa de
// apontar de volta para o hub.
export const hasCapacityPolicies = isEnabled =>
  Boolean(isEnabled('assignment_v2') && isEnabled('advanced_assignment'));

export const SINGLE_OPTION_ROUTE = 'agent_assignment_policy_index';
